import { NgModule, ModuleWithProviders, Optional, SkipSelf } from '@angular/core'
import { HttpModule } from '@angular/http'
import { Title }  from '@angular/platform-browser'

import { Angular2TokenService } from 'angular2-token'
import { ModalModule } from 'ng2-bootstrap/src/modal'
import { PaginationModule } from 'ng2-bootstrap/src/pagination'
import { TooltipModule } from 'ng2-bootstrap/src/tooltip'
import { ToastyModule, ToastyService, ToastyConfig, ToastyComponent } from 'ng2-toasty'
import { TranslateModule } from '@ngx-translate/core'

import { AlertService } from './alert'
import { Authentication, IAuthentication, Authorization, IAuthorization, AuthorizationConfig } from './auth'
import { ConfirmService, ConfirmComponent } from './confirm'
import { Body } from './dom'
import { FileUploadsService } from './file-uploads'
import { ValidatorsService } from './forms'
import { AppHttp, AppHttpBroadcaster, IAppHttp } from './http'
import { PluralizeService } from './i18n'
import { RouterAuthorizer } from './router'
import { InitDataLoaderResolver } from './init-data-loader.resolver'
import { CommonModule } from '@angular/common'
import { ActionCableService } from "angular2-actioncable"
import { WebviewTimelogService } from 'pages/webview/webview-timelog.service'
import { WebviewLogService } from 'pages/webview/webview-log.service'
import { YandexMetrikaService } from 'pages/admin/yandex-metrika.service'


@NgModule({
  imports: [
    HttpModule,
    ModalModule.forRoot(),
    PaginationModule.forRoot(),
    TooltipModule.forRoot(),
    ToastyModule.forRoot(),
    TranslateModule.forRoot(),
    CommonModule
  ],
  declarations: [
    ConfirmComponent,
  ],
  exports: [
    ToastyComponent,
    ConfirmComponent,
    TranslateModule
  ],
  providers: [
    ActionCableService,
    Angular2TokenService,
    ToastyService,
    { provide: ToastyConfig, useValue: { limit: 5, showClose: true, position: 'bottom-right', timeout: 5000 , theme: 'bootstrap' } }
  ]
})

export class CoreModule {
  constructor (@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import it in the AppModule only')
    }
  }

  static forRoot(params: Object): ModuleWithProviders {
    return {
      ngModule: CoreModule,
      providers: [
        Title,
        Authentication,
        { provide: IAuthentication, useExisting: Authentication },
        Authorization,
        { provide: IAuthorization, useExisting: Authorization },
        { provide: AuthorizationConfig, useValue: params['authorizationConfig'] },
        AlertService,
        ConfirmService,
        Body,
        FileUploadsService,
        ValidatorsService,
        AppHttp,
        AppHttpBroadcaster,
        { provide: IAppHttp, useExisting: AppHttp },
        PluralizeService,
        RouterAuthorizer,
        InitDataLoaderResolver,
        WebviewTimelogService,
        WebviewLogService,
        YandexMetrikaService
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/core/core.module.ts